import { render, staticRenderFns } from "./OGenerate.vue?vue&type=template&id=66bd28d6&scoped=true&"
import script from "./OGenerate.vue?vue&type=script&lang=js&"
export * from "./OGenerate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd28d6",
  null
  
)

export default component.exports